import { Injectable } from '@angular/core';
import { REGISTER_SUBSCRIPTION } from '../actions/index';
import { AuthLogoutAction } from '../actions/auth-actions';
import { Action } from '../action';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { mapTo } from 'rxjs/operators';

@Injectable()
export class RegisterContractEffects {
	@Effect()
	clickContinue$: Observable<Action> = this.actions$.pipe(ofType(REGISTER_SUBSCRIPTION.CLICK_LOGOUT), mapTo(new AuthLogoutAction()));

	constructor(private actions$: Actions) {}
}
